var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_84",
    "data-name": "Groupe 84",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_84",
    "data-name": "Trac\\xE9 84",
    d: "M11.333,12.667V9.333a3.333,3.333,0,0,1,6.667,0M14.667,16v1.667M9.667,21h10a1.666,1.666,0,0,0,1.667-1.667v-5a1.666,1.666,0,0,0-1.667-1.667h-10A1.666,1.666,0,0,0,8,14.333v5A1.666,1.666,0,0,0,9.667,21Z",
    transform: "translate(-4.667 -3.5)",
    fill: "none",
    stroke: "#005151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_85",
    "data-name": "Trac\\xE9 85",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecu);
export default __webpack_public_path__ + "static/media/secu.442050df0fe44ddabb3541ffb78a5bf9.svg";
export { ForwardRef as ReactComponent };